import api from "./api"

export const login = async (email, password) => {
  const response = await api.post("/auth/login", { email, password })
  return response.data
}

export const logout = async () => {
  const response = await api.get("/auth/logout")
  return response.data
}

export const getMe = async () => {
  const response = await api.get("/auth/me")
  return response.data
}

export const forgotPassword = async (email) => {
  const response = await api.post("/auth/forgot-password", { email })
  return response.data
}

export const resetPassword = async (token, password) => {
  const response = await api.post(`/auth/reset-password/${token}`, { password })
  return response.data
}

export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.post("/auth/change-password", { currentPassword, newPassword })
  return response.data
}

